import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { OtherAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-other-slot',
    templateUrl: './other-slot.component.html',
    styleUrl: './other-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OtherSlotComponent implements SheetSlotComponentBase {

	@Input() action!: OtherAction;
	value = null;

	constructor() {
	}
}